module.exports = __webpack_public_path__ + "media/img/illustrations/icons/filter-add-6a95dd529a2ea8af1b9f4bc0a4d942e6.svg";